import { render, staticRenderFns } from "./layout-bookmark.vue?vue&type=template&id=42d3c996&scoped=true&"
import script from "./layout-bookmark.vue?vue&type=script&lang=js&"
export * from "./layout-bookmark.vue?vue&type=script&lang=js&"
import style0 from "./layout-bookmark.vue?vue&type=style&index=0&id=42d3c996&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d3c996",
  null
  
)

export default component.exports